import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function TeamSection() {
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20y%20quiero%20una%20asesor%C3%ADa%20para%20mi%20proyecto.';
  return <section className="py-24 md:py-32 bg-gerfaj-dark-lighter relative overflow-hidden" data-id="element-167">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-168">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-169">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-170">
            <div className="aspect-[4/3] rounded-3xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-171">
              <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Equipo Gerfaj en obra" className="w-full h-full object-cover" loading="lazy" decoding="async" width={800} height={600} data-id="element-172" />
              <div className="absolute inset-0 bg-gradient-to-t from-gerfaj-dark/80 to-transparent" data-id="element-173"></div>
            </div>

            <div className="absolute -bottom-6 -right-6 md:-right-10 bg-gerfaj-blue p-6 rounded-2xl border border-white/10 shadow-xl hidden sm:block" data-id="element-174">
              <div className="text-4xl font-montserrat font-bold text-gerfaj-orange mb-1" data-id="element-175">
                30+
              </div>
              <div className="text-sm text-gray-300 font-medium uppercase tracking-wider" data-id="element-176">
                Años de
                <br data-id="element-177" />
                Experiencia
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex flex-col justify-center items-center text-center pt-6 lg:pt-0" data-id="element-178">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white leading-tight mb-6 text-center" data-id="element-179">
              Manos expertas cuidando cada rincón de tu obra
            </h2>

            <p className="text-lg text-gray-200 font-medium leading-relaxed mb-8 font-inter text-center max-w-2xl" data-id="element-180">
              Detrás de tu obra hay un equipo interdisciplinario profesional. No
              delegamos tu tranquilidad a terceros; nosotros lideramos la
              ejecución con ingenieros, arquitectos y maestros comprometidos con
              la excelencia.
            </p>

            <div className="flex justify-center w-full" data-id="element-181">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl cta-glow transition-colors duration-300 w-[90%] sm:w-auto min-h-[60px]" data-id="element-182">
                <MessageCircle className="w-6 h-6" data-id="element-183" />
                Hablar ahora con un experto del equipo
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}